import { useUserStore } from '../../../modules/Auth/stores/authStore';
import { Permissions } from '../permissions';
import {
  getUserPermissions,
  hasAllPermissions,
  hasAllPermissionsWithPrefix,
  hasAnyPermission,
  hasAnyPermissionWithPrefix,
  hasExactPermission,
} from '../utils';

interface IPermissionGuardProps {
  necessaryPermission: Permissions[] | Permissions | string;
  mode?: 'exact' | 'all' | 'any' | 'all-prefix' | 'any-prefix';
  children?: React.ReactNode;
}

export function PermissionGuard({
  necessaryPermission: necessaryPermissions,
  mode = 'exact',
  children,
}: IPermissionGuardProps) {
  const user = useUserStore((s) => s.user);
  if (!user) return <></>;

  const userPermissions = getUserPermissions(user);

  if (mode === 'exact') {
    const permission = necessaryPermissions as Permissions;
    if (!hasExactPermission(userPermissions, permission)) {
      return <></>;
    }
  }

  if (mode === 'all') {
    const permissions = necessaryPermissions as Permissions[];
    if (!hasAllPermissions(userPermissions, permissions)) {
      return <></>;
    }
  }

  if (mode === 'any') {
    const permissions = necessaryPermissions as Permissions[];
    if (!hasAnyPermission(userPermissions, permissions)) {
      return <></>;
    }
  }

  if (mode === 'all-prefix') {
    const prefix = necessaryPermissions as string;
    if (!hasAllPermissionsWithPrefix(userPermissions, prefix)) {
      return <></>;
    }
  }

  if (mode === 'any-prefix') {
    const prefix = necessaryPermissions as string;
    if (!hasAnyPermissionWithPrefix(userPermissions, prefix)) {
      return <></>;
    }
  }

  return <>{children}</>;
}
